import React from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';
import menu from '../../mock-data/menu.json';
import { useResize } from '../../hooks';
import { Container, Nav, Menu, Button, Hamburguer } from './index.styled';

const MenuHeaderComponent = ({ openMenuMobile, color }) => {
  const { isMobile } = useResize();

  const openMobile = () => {
    openMenuMobile(true);
  };
  return (
    <Container>
      {!isMobile && (
        <Nav>
          <Menu>
            {menu.map(button => {
              return (
                <Button key={button.title} color={color}>
                  <Link to={`../${button.anchor}`}>{button.title}</Link>
                </Button>
              );
            })}
          </Menu>
        </Nav>
      )}
      {isMobile && (
        <Hamburguer
          onClick={openMobile}
          color={color === 'white' ? '#FFF' : '#3c0548'}
        />
      )}
    </Container>
  );
};

MenuHeaderComponent.propTypes = {
  openMenuMobile: PropTypes.func,
  color: PropTypes.string,
};

MenuHeaderComponent.defaultProps = {
  openMenuMobile: () => {},
  color: 'white',
};

export default MenuHeaderComponent;
